// WhatsApp External Link Modal
class WhatsAppModal {
  constructor() {
    this.trigger = document.getElementById('whatsapp-trigger');
    this.modal = document.getElementById('contact-modal');
    
    if (!this.trigger || !this.modal) return;
    
    this.overlay = this.modal.querySelector('.contact-modal__overlay');
    this.closeBtn = this.modal.querySelector('.contact-modal__close');
    this.cancelBtn = this.modal.querySelector('.contact-modal__cancel');
    this.confirmBtn = this.modal.querySelector('.contact-modal__confirm');
    this.url = this.trigger.dataset.url;
    
    this.init();
  }
  
  init() {
    this.trigger.addEventListener('click', () => this.open());
    this.closeBtn.addEventListener('click', () => this.close());
    this.cancelBtn.addEventListener('click', () => this.close());
    this.confirmBtn.addEventListener('click', () => this.confirm());
    this.overlay.addEventListener('click', () => this.close());
    
    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.modal.hidden) {
        this.close();
      }
    });
  }
  
  open() {
    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    this.confirmBtn.focus();
  }
  
  close() {
    this.modal.hidden = true;
    document.body.style.overflow = '';
    this.trigger.focus();
  }
  
  confirm() {
    window.open(this.url, '_blank', 'noopener,noreferrer');
    this.close();
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new WhatsAppModal());
} else {
  new WhatsAppModal();
}

